<site-layout class="narrow push">
  <h2 class="text-header text-bold text-center text-dark mb-2" i18n="@@front.unsubscribe.title">Email Unsubscription</h2>
  <div class="p-3"></div>
  
  <loading *ngIf="loading">
    <ng-container i18n="@@front.unsubscribe.loading">Unsubscribing you from the mail list</ng-container>
  </loading>

  <error *ngIf="error">
    {{error}}
  </error>

  <success *ngIf="success">
    <ng-container i18n="@@front.unsubscribe.success">You have been sucessfully removed from this mail list</ng-container>
  </success>

  <div class="p-2 text-center">
    <a routerLink="/" class="btn btn-primary" i18n="@@front.pageNotFound.backButton">Go back to home page</a>
  </div>
</site-layout>